const SITE_URL = 'https://www.domoelec.ma';
const SITE_NAME = 'DOMOELEC';
const SITE_LOGO_URL = `${SITE_URL}/images/logo-domoelec.png`;

export const ensureMetaTag = (attrName, attrValue) => {
  let meta = document.head.querySelector(`meta[${attrName}="${attrValue}"]`);
  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute(attrName, attrValue);
    document.head.appendChild(meta);
  }
  return meta;
};

export const ensureCanonicalLink = () => {
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
  }
  return link;
};

// Tous les blocs ld+json de ce site sont gérés par le SEO (injectés par le
// backend dans le HTML initial ou ajoutés par React après navigation).
// Les supprimer tous garantit l'absence de blocs obsolètes entre pages.
export const clearSeoJsonLd = () => {
  document.head
    .querySelectorAll('script[type="application/ld+json"]')
    .forEach((node) => node.remove());
};

export const appendJsonLd = (block) => {
  if (!block) return;
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.text = JSON.stringify(block);
  document.head.appendChild(script);
};

export const buildOrganizationJsonLd = () => ({
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: SITE_NAME,
  url: `${SITE_URL}/`,
  logo: SITE_LOGO_URL,
  email: 'info@domoelec.ma',
  telephone: '+212522340659',
  sameAs: [
    'https://www.linkedin.com/company/domoelecsarl/',
    'https://www.youtube.com/@DOMOELEC-CFA',
    'https://www.instagram.com/domo.elec/'
  ]
});

export const buildBreadcrumbJsonLd = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: (items || []).map((item, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: item.name,
    item: item.item
  }))
});

// Remplace l'ensemble des données structurées par : Organization + blocs page.
export const setPageJsonLd = (blocks = []) => {
  clearSeoJsonLd();
  [buildOrganizationJsonLd(), ...blocks].forEach(appendJsonLd);
};

export { SITE_URL, SITE_NAME, SITE_LOGO_URL };
